import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import TextInput from '../../../Shared/TextInput/TextInput';
import {validateInput} from '../../../../utilities/validation/InputValidation';
import {familyMemberTexts, RECIPIENT_TYPES, FLOW_STEPS, recipientFields} from '../Conatant';
import {setRecipientType, updateDraftMemberField, resetDraftMember} from '../OrganizationEmployeeSlice';
import BtnNextStep from '../BtnNextStep';

function RecipientSelectionStep(props) {
  const {familyMembers, recipientType, draftMember} = props;
  const [errors, setErrors] = useState({});

  useEffect(() => {
    props.resetDraftMember();
    setErrors({});
  }, []);

  const handleRecipientChange = (type) => {
    props.setRecipientType(type);
    setErrors({});
  };

  const handleInputChange = (field, value, type) => {
    props.updateDraftMemberField({field, value});
    const error = validateInput(value, type);
    setErrors((prev) => {
      const next = {...prev};
      if (error) next[field] = error;
      else delete next[field];
      return next;
    });
  };

  const validateForm = () => {
    const nextErrors = {};

    if (recipientType === RECIPIENT_TYPES.FAMILY) {
      recipientFields.forEach((field) => {
        const error = validateInput(draftMember?.[field.key], field.inputType);
        if (error) {
          nextErrors[field.key] = error;
        }
        if (field.checkDuplicate && draftMember?.[field.key]) {
          const duplicate = familyMembers.some((item) => item[field.key] === draftMember[field.key]);
          if (duplicate) {
            nextErrors[field.key] = familyMemberTexts.errors[field.duplicateErrorKey] || error;
          }
        }
      });
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  return (
    <>
    <div className={`${props.className} recipient-selection-step`}>
      <div className='recipient-options' role='radiogroup' >
        <button
          type='button'
          role='radio'
          aria-checked={recipientType === RECIPIENT_TYPES.SELF}
          className={`recipient-option ${recipientType === RECIPIENT_TYPES.SELF ? 'selected' : ''}`}
          onClick={() => handleRecipientChange(RECIPIENT_TYPES.SELF)}>
          <span className='recipient-option-label'>{familyMemberTexts.recipient.self}</span>
          <span className={`recipient-radio ${recipientType === RECIPIENT_TYPES.SELF ? 'checked' : ''}`} />
        </button>

        <button
          type='button'
          role='radio'
          aria-checked={recipientType === RECIPIENT_TYPES.FAMILY}
          className={`recipient-option ${recipientType === RECIPIENT_TYPES.FAMILY ? 'selected' : ''}`}
          onClick={() => handleRecipientChange(RECIPIENT_TYPES.FAMILY)}>
          <span className='recipient-option-label'>{familyMemberTexts.recipient.family}</span>
          <span className={`recipient-radio ${recipientType === RECIPIENT_TYPES.FAMILY ? 'checked' : ''}`} />
        </button>
      </div>

      {recipientType === RECIPIENT_TYPES.FAMILY && (
        <div className='recipient-fields'>
          {recipientFields.map((field) => (
            <TextInput
              key={field.key}
              value={draftMember?.[field.key] || ''}
              error={errors[field.key]}
              id={field.key}
              name={field.key}
              type={field.type}
              placeholder={field.label}
              onChange={(e) => handleInputChange(field.key, e.target.value, field.inputType)}
              required='required'
            />
          ))}
        </div>
      )}

    </div>
      <BtnNextStep
        text={familyMemberTexts.continue}
        onclick={validateForm}
        nextStep={FLOW_STEPS.ALLOCATION}
        errorText={Object.values(errors).some(Boolean) ? familyMemberTexts.errors.completeDetails : ''}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  familyMembers: state.organizationEmployee.familyMembers,
  recipientType: state.organizationEmployee.recipientType,
  draftMember: state.organizationEmployee.draftMember,
});

const mapDispatchToProps = {
  setRecipientType,
  updateDraftMemberField,
  resetDraftMember,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecipientSelectionStep);
